var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.$t(_vm.hint),
    placement: 'right-start',
    classes: ['u-tooltip', 'q-tooltip-w300', 'u-typography-helvetica u-text u-text--xs'],
    offset: -12
  }),expression:"{\n    content: $t(hint),\n    placement: 'right-start',\n    classes: ['u-tooltip', 'q-tooltip-w300', 'u-typography-helvetica u-text u-text--xs'],\n    offset: -12\n  }"}],staticClass:"info-tooltip",on:{"click":function($event){$event.stopPropagation();}}},[_c('u-icon',{staticClass:"info-tooltip__icon",attrs:{"name":"help-circle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }